import { Option } from "./option";

export class OptionList extends Array<Option> {
  getLabel(value: string | number | null | undefined): string {
    if (value === null || value === undefined) return "";
    const stringValue = String(value);
    return this.find((opt) => opt.value === stringValue)?.label ?? stringValue;
  }
}
